import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_148_petty_cash_vouchers: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "32",
    },
    title: "Petty cash vouchers",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "voucher_no",
            Name: "petty_cash_voucher_summary",
            BindValue: "grid_journal_voucher",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/petty_cash_voucher/<id>",
                },
                ActionType: "Edit",
                ScreenId: "32",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "petty_voucher",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "petty_cash_voucher_summary",
              TableName: "vouchers",
              DisplayName: "vouchers",
              Query:
                "SELECT `vouchers`.id,vouchers.voucher_no,`voucher_date`,ledgers.ledger_name AS 'from_ledger',l.ledger_name AS 'to_ledger',users.username,amount,(SELECT users.username FROM users WHERE id=vouchers.modified_by limit 1) AS modified_by  FROM vouchers LEFT JOIN users ON users.id=vouchers.created_by LEFT JOIN `voucher_details` ON `voucher_details`.parent_id=vouchers.id LEFT JOIN ledgers ON ledgers.id=voucher_details.`ledger_id`  LEFT JOIN ledgers l ON l.id=voucher_details.`to_ledger`  WHERE voucher_type='Petty'",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher No.",
                  BindValue: "txt_voucher_no",
                  Json_Attribute: "voucher_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Voucher date",
                  IsMandatory: false,
                  BindValue: "txt_date",
                  Json_Attribute: "voucher_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Credit",
                  BindValue: "txt_from",
                  Json_Attribute: "from_ledger",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Debit",
                  BindValue: "txt_to",
                  Json_Attribute: "to_ledger",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  BindValue: "txt_amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Created by",
                  BindValue: "txt_created_by",
                  Json_Attribute: "username",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
